import type { ParentTicketWithMeta } from '@/store/parentTicket'
import type { FEDispatchSelection } from '@/components/forms/parentTicket/FEDispatchFlow'
import { buildDispatchSelectionsFromTicket } from '@/components/forms/parentTicket/feDispatchSelectionFromTicket'

export type DispatchToggleParams = {
  checked: boolean
  isEditMode: boolean
  hasPersistedDispatch: boolean
  editTicket?: ParentTicketWithMeta
  currentPrimary: FEDispatchSelection | null
  currentAdditionalFes: FEDispatchSelection[]
  /** @deprecated Prefer currentAdditionalFes */
  currentBackups?: FEDispatchSelection[]
}

export type DispatchToggleResult = {
  nextPrimary: FEDispatchSelection | null
  nextAdditionalFes: FEDispatchSelection[]
  /** @deprecated Prefer nextAdditionalFes */
  nextBackups: FEDispatchSelection[]
}

/**
 * Computes FE dispatch selection state after toggling dispatch requirement.
 * Edit tickets with persisted FE assignments keep/restores dispatch context.
 */
export function resolveDispatchSelectionsOnToggle({
  checked,
  isEditMode,
  hasPersistedDispatch,
  editTicket,
  currentPrimary,
  currentAdditionalFes,
  currentBackups,
}: DispatchToggleParams): DispatchToggleResult {
  const currentAdditionals = currentAdditionalFes ?? currentBackups ?? []

  if (!checked) {
    return { nextPrimary: null, nextAdditionalFes: [], nextBackups: [] }
  }

  if (isEditMode && hasPersistedDispatch && editTicket) {
    const { primary, additionalFes } = buildDispatchSelectionsFromTicket(editTicket)
    const nextAdditionalFes = additionalFes.length > 0 ? additionalFes : currentAdditionals
    return {
      nextPrimary: primary ?? currentPrimary,
      nextAdditionalFes,
      nextBackups: nextAdditionalFes,
    }
  }

  return {
    nextPrimary: currentPrimary,
    nextAdditionalFes: currentAdditionals,
    nextBackups: currentAdditionals,
  }
}
